const cdnbasepath = `https://${process.env.REACT_APP_CDNBASEPATH}`;
export default {
  LOADER: `${cdnbasepath}/client/assets/images/icon/loader.gif`,
  NOSTORES: `${cdnbasepath}/nostores.gif`,
  PAYTM_LOGO: `${cdnbasepath}/client/assets/images/paytm_logo.jpg`,
  nnnowLogoUrl:
    "https://static.omuni.com/omuni/omuni_site_header.png",
  nnnowMobileLogo: `${cdnbasepath}/client/assets/images/nnnow-logo-beta_1.png`,
  nnnowBaseUrl: "https://odin-qa.ailiens.com/",
  gmailLogo: `${cdnbasepath}/google-social-login.svg`,
  fbLogo: `${cdnbasepath}/facebook.png`,
  sadFaceLogo: `${cdnbasepath}/sad_face.png`,
  googleMapsUrl: "//maps.google.com/maps?z=12&t=m&q=",
  noImg: `${cdnbasepath}/client/assets/images/icon/defaultSkuImage.png`,
  fpImage: `${cdnbasepath}/Forgot+password+(1).png`,
  missedImage: `${cdnbasepath}/phone-number.png`,
  resetImage: `${cdnbasepath}/reset_password.png`,
  brush_stroke: `${cdnbasepath}/brush-stroke.png`,
  cvvImge: `${cdnbasepath}/client/assets/images/checkout-final-17.png`,
  favorites_no_products: `${cdnbasepath}/client/assets/images/my-favorites-no-product.png`,
  sadSmileyImage: `${cdnbasepath}/client/assets/images/sad_smiley.png`,
  noAddressImage: `${cdnbasepath}/client/assets/images/address_map.jpg`,
  storeLocator_illustration: `${cdnbasepath}/locate+store+illustration.png`,
  orderdetailsFooter: `${cdnbasepath}/client/assets/images/orderdetails-footer.png`,
  orderdetailsMobileFooter: `${cdnbasepath}/client/assets/images/orderdetails-mobile-footer.png`,
  feebackCustomerImage: {
    IMAGE: [
      `${cdnbasepath}/client/assets/images/app/hari.png`,
      `${cdnbasepath}/client/assets/images/app/gokul.png`,
    ],
  },
  customerRating: {
    RATING: `${cdnbasepath}/client/assets/images/app/ratings.png`,
  },
  APP_SCREEN: `${cdnbasepath}/client/assets/images/app/app-screens.jpg`,
  APP_STORE: `${cdnbasepath}/client/assets/images/app/apple-logo.png`,
  PLAY_STORE: `${cdnbasepath}/client/assets/images/app/play-logo.png`,
  GETAPP: `${cdnbasepath}/client/assets/appDownload.png`,
  PDP_BANNER_IMAGES: {
    desktop: `${cdnbasepath}/client/assets/images/pdp/pdp_desktop_1.jpg`,
    mobile: `${cdnbasepath}/client/assets/images/pdp/pdp_mobile_1.jpg`,
  },
  LOYALTY_EXPIRY_ICON: `${cdnbasepath}/loyalty_expiry.png`,
  VISA_CARD: `${cdnbasepath}/visa.png`,
  MASTER_CARD: `${cdnbasepath}/master.png`,
  AMEX_CARD: `${cdnbasepath}/amex.png`,
  LOYALTY_GIFT_IMAGE: `${cdnbasepath}/loyalty_gift.png`,
  PDP_NON_RETURNABLE_LOGO: `${cdnbasepath}/client/assets/images/pdp/pdp_non_returnable_logo.png`,
  SIZE_NUDGE_INFO_LOGO: {
    desktop: `${cdnbasepath}/client/assets/images/filter/info-logo-desktop.png`,
    mobile: `${cdnbasepath}/client/assets/images/filter/info-logo-mobile.png`,
  },
};
